function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.666016 5C1.81935 2.07333 4.66602 0 7.99935 0C11.3327 0 14.1793 2.07333 15.3327 5C14.1793 7.92667 11.3327 10 7.99935 10C4.66602 10 1.81935 7.92667 0.666016 5ZM13.8795 5C12.7795 2.75333 10.5261 1.33333 7.99945 1.33333C5.47279 1.33333 3.21945 2.75333 2.11945 5C3.21945 7.24667 5.47279 8.66667 7.99945 8.66667C10.5261 8.66667 12.7795 7.24667 13.8795 5ZM7.99935 3.33333C8.91935 3.33333 9.66602 4.08 9.66602 5C9.66602 5.92 8.91935 6.66667 7.99935 6.66667C7.07935 6.66667 6.33268 5.92 6.33268 5C6.33268 4.08 7.07935 3.33333 7.99935 3.33333ZM4.99935 5C4.99935 3.34667 6.34602 2 7.99935 2C9.65268 2 10.9993 3.34667 10.9993 5C10.9993 6.65333 9.65268 8 7.99935 8C6.34602 8 4.99935 6.65333 4.99935 5Z"
});

var SvgVisibility = function SvgVisibility(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisibility, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visibility.3b7807ad.svg";
export { ForwardRef as ReactComponent };